import { on, fire } from 'delegated-events'
import { debounce } from 'lodash'
import { handleValidation } from './validation'
// import hasEventListener from './hasEventListener'

export const handleInitialLoad = (state, form) => {
  const paymentMethods = getAvailablePaymentMethods(form)
  const amountFields = form ? form.querySelectorAll('select[name="Amount"]') : null

  paymentMethods.forEach((method) => {
    if (method.classList.contains('checked')) {
      const value = method.dataset.key
      state.currentPaymentMethod = value
      setupPaymentOptionVisibility(state, paymentMethods)
    }
  })

  if (amountFields.length) {
    state.currentTotal = parseInt(amountFields[0].value)
  }
}

export const getAvailablePaymentMethods = (form) => {
  return form ? form.querySelectorAll('.payment-method-radio-group') : null
}

export const setCurrentPaymentMethod = (state, form) => {
  const paymentMethods = getAvailablePaymentMethods(form)

  if (!paymentMethods) {
    return
  }

  paymentMethods.forEach((method) => {
    method.addEventListener('change', () => {
      if (method.classList.contains('checked')) {
        const value = method.dataset.key
        state.currentPaymentMethod = value
        setupPaymentOptionVisibility(state, paymentMethods)
      }
    })
  })
}

export const setupPaymentOptionVisibility = (state, paymentMethods) => {
  paymentMethods.forEach((method) => {
    const field = document.getElementById(`payment-${method.dataset.key}`)
    if (field.classList.contains(`payment-${state.currentPaymentMethod}`)) {
      field.classList.contains('hidden') ? field.classList.remove('hidden') : () => {}
    } else {
      field.classList.contains('hidden') ? () => {} : field.classList.add('hidden')
    }
  })

  fire(document.documentElement, 'payment:updated-method', { state: state })
}

export const setTotal = (state, amount, fields, formatBefore = '$', formatAfter = '.00') => {
  state.currentTotal = Number.parseFloat(amount.replace('$', ''))
  setTotalFields(fields, amount, formatBefore, formatAfter)
  fire(document.documentElement, 'payment:updated-amount', { state: state })
}

export const setTotalFields = (fields, amount, formatBefore = '$', formatAfter = '.00') => {
  fields.forEach((field) => {
    field.textContent = `${formatBefore}${amount}${formatAfter}`
  })
}

export const setupPayment = (state, form) => {
  switch (state.currentPaymentMethod) {
    case 'credit-card':
      setupStripeCard(state)
      doSubmit(state, form)
      break
    case 'paypal':
      setupPaypal(state, form)
      break
    case 'apple-pay':
      setupApplePay(state, form, `Anita's SSHS Donation`)
      break
    case 'google-pay':
      setupGooglePay(state, form, `Anita's SSHS Donation`)
      break
    case 'bitcoin':
      break
    default:
      break
  }
  on('click', '[formnovalidate]', () => {
    form.skipValidation = true
  })
}

export const setupStripeCard = (state) => {
  const style = {
    base: {
      fontSize: '16px',
      fontFamily: 'Helvetica Neue, sans-serif',
      color: '#2c2c2c',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#b4b4b4',
      },
    },
    invalid: {
      color: '#b9112a',
    },
  }

  const card = state.stripe.elements().create('card', { style })

  card.mount('#card-element')
  state.stripeCard = card

  card.addEventListener('change', ({ error }) => {
    const displayError = document.getElementById('card-errors')
    if (error) {
      displayError.textContent = error.message
    } else {
      displayError.textContent = ''
    }
  })
}

export const setupApplePay = (state, form, label = "Anita's SSHS") => {
  const submitButton = form ? form.querySelector('[name=action_submit]') : null
  state.stripeElements = state.stripe.elements()

  const paymentRequest = state.stripe.paymentRequest({
    country: 'US',
    currency: 'usd',
    total: {
      label: label,
      amount: state.currentTotal * 100,
    },
    requestPayerName: true,
    requestPayerEmail: true,
  })

  const paymentRequestButton = state.stripeElements.create('paymentRequestButton', {
    paymentRequest: paymentRequest,
    style: {
      paymentRequestButton: {
        height: '55px',
      },
    },
  })

  // Check the availability of the Payment Request API first
  paymentRequest.canMakePayment().then(function (result) {
    if (result && result.applePay) {
      document.getElementById('payment-apple-pay-notice').style.display = 'none'
      paymentRequestButton.mount('#payment-apple-pay')
      state.paymentRequest = paymentRequest
    } else {
      // document.getElementById('payment-apple-pay').style.display = 'none'
    }
  })

  paymentRequest.on('token', (e) => {
    submitButton.disabled = true

    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', 'stripeApplePayToken')
    hiddenInput.setAttribute('value', e.token.id)
    form.appendChild(hiddenInput)

    form.submit()
  })
}

export const setupGooglePay = (state, form, label = "Anita's SSHS") => {
  const submitButton = form ? form.querySelector('[name=action_submit]') : null
  state.stripeElements = state.stripe.elements()

  const paymentRequest = state.stripe.paymentRequest({
    country: 'US',
    currency: 'usd',
    total: {
      label: label,
      amount: state.currentTotal * 100,
    },
    requestPayerName: true,
    requestPayerEmail: true,
  })

  const paymentRequestButton = state.stripeElements.create('paymentRequestButton', {
    paymentRequest: paymentRequest,
    style: {
      paymentRequestButton: {
        height: '55px',
      },
    },
  })

  // Check the availability of the Payment Request API first
  paymentRequest.canMakePayment().then(function (result) {
    if (result && !result.applePay) {
      document.getElementById('payment-google-pay-notice').style.display = 'none'
      paymentRequestButton.mount('#payment-google-pay')
      state.paymentRequest = paymentRequest
    } else {
      // document.getElementById('payment-google-pay').style.display = 'none'
    }
  })

  paymentRequest.on('token', (e) => {
    submitButton.disabled = true

    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', 'stripeGooglePayToken')
    hiddenInput.setAttribute('value', e.token.id)
    form.appendChild(hiddenInput)

    form.submit()
  })
}

export const setupProcessingFees = (state) => {
  const processingFees = document.querySelector('.processing-fees')
  const totalAmountDisplays = document.querySelectorAll('.payment-total-field')
  const processingAmountDisplays = document.querySelectorAll('.payment-total-field-with-fees')
  const chargeAmount = document.querySelector('input[type=hidden][name=ChargeAmount]')

  if (!processingFees) {
    return
  }

  const setChargeAmount = (value) => {
    if (chargeAmount) {
      chargeAmount.name = 'ChargeAmount'

      if (value) {
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        })
        chargeAmount.value = formatter.format(value).slice(1)
      }
    }
  }

  const unsetChargeAmount = () => {
    if (chargeAmount) {
      chargeAmount.name = null
    }
  }

  const showProcessingFeesOption = () => {
    processingFees.classList.remove('hidden')
    setChargeAmount()
  }

  const hideProcessingFeesOption = () => {
    processingFees.querySelector('input[type=checkbox]').checked = false
    processingFees.classList.add('hidden')
    unsetChargeAmount()
  }

  const updateProcessingFeesOptions = () => {
    if (state.currentTotal) {
      processingFees.querySelector('input[type=checkbox]').checked = false

      if (totalAmountDisplays.length) {
        totalAmountDisplays.forEach((totalAmountDisplay) => {
          totalAmountDisplay.classList.remove('hidden')
        })
      }

      if (processingAmountDisplays.length) {
        processingAmountDisplays.forEach((processingAmountDisplay) => {
          processingAmountDisplay.classList.add('hidden')
        })
      }

      unsetChargeAmount()
      showProcessingFeesOption()
    } else {
      hideProcessingFeesOption()
    }
  }

  const setFees = () => {
    const feeAmount = parseFloat(state.currentTotal * 0.035)
    const newAmount = feeAmount + state.currentTotal
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    })

    setChargeAmount(newAmount)

    if (processingAmountDisplays.length) {
      processingAmountDisplays.forEach((processingAmountDisplay) => {
        processingAmountDisplay.textContent = formatter.format(newAmount)
      })
    }
  }

  const handleProcessingFeesCheckbox = () => {
    const checkbox = document.querySelector('input[name=IncludeProcessingFees]')

    if (!checkbox) {
      return
    }

    if (checkbox.checked) {
      setFees()

      if (processingAmountDisplays.length) {
        processingAmountDisplays.forEach((processingAmountDisplay) => {
          processingAmountDisplay.classList.remove('hidden')
        })
      }

      if (totalAmountDisplays.length) {
        totalAmountDisplays.forEach((totalAmountDisplay) => {
          totalAmountDisplay.classList.add('hidden')
        })
      }

      setChargeAmount()
    } else {
      if (totalAmountDisplays.length) {
        totalAmountDisplays.forEach((totalAmountDisplay) => {
          totalAmountDisplay.classList.remove('hidden')
        })
      }

      if (processingAmountDisplays.length) {
        processingAmountDisplays.forEach((processingAmountDisplay) => {
          processingAmountDisplay.classList.add('hidden')
        })
      }

      unsetChargeAmount()
    }
  }

  on('payment:updated-amount', 'html', (e) => {
    state = e.detail.state
    updateProcessingFeesOptions()
    handleProcessingFeesCheckbox()
  })

  on('payment:updated-method', 'html', (e) => {
    state = e.detail.state
    updateProcessingFeesOptions()
  })

  on('change', 'input[name=IncludeProcessingFees]', handleProcessingFeesCheckbox)

  if (totalAmountDisplays) {
    processingFees.classList.add('hidden')
  }

  unsetChargeAmount()
}

export const doSubmit = (state, form) => {
  const submitButton = form ? form.querySelector('[name=action_submit]') : null

  const addEventListener = () => {
    form.addEventListener('submit', handleSubmit, { once: true })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const isValid = handleValidation(form)

    if (!isValid) {
      addEventListener()

      return false
    }

    // Handle PayPal
    if (document.querySelector('[name=paypalPayload]')) {
      return true
    }

    // Handle Stripe
    submitButton.disabled = true
    submitButton.classList.add('btn-loading')

    state.stripe
      .createToken(state.stripeCard, {
        name: form.querySelector('[name=CardholderName]').value,
      })
      .then((result) => {
        if (result.error) {
          const errorElement = document.getElementById('card-errors')
          errorElement.textContent = result.error.message
          submitButton.disabled = false
          addEventListener()
        } else {
          stripeTokenHandler(result.token, form)
        }
      })
    return false
  }

  if (form.getAttribute('listener') !== 'true') {
    addEventListener()
    form.setAttribute('listener', 'true')
  }
}

export const stripeTokenHandler = (token, form) => {
  //const submitButton = form ? form.querySelector('[name=action_submit]') : null

  //const formMessages = form.querySelector('.form-messages')
  const hiddenInput = document.createElement('input')
  hiddenInput.setAttribute('type', 'hidden')
  hiddenInput.setAttribute('name', 'stripeToken')
  hiddenInput.setAttribute('value', token.id)
  form.appendChild(hiddenInput)

  //submitButton.disabled = true

  form.submit()
  /*
  ajax
    .url(form.action)
    .body(new FormData(form))
    .post()
    .json((res) => {
      if (res.success) {
        form.querySelectorAll('.form-content').forEach((x) => x.classList.add('hidden'))
        form.reset()
      }

      if (res.message) {
        showFormMessages(formMessages, res.message, res.success, false)
      }
    })
    .catch(() => {
      showFormMessages(formMessages, 'Sorry, there was a problem with your submission')
    })
    .finally(() => {
      submitButton.disabled = false
    })
    */
}

export const showFormMessages = (holder, message, success, autoHide) => {
  holder.style.display = 'block'
  holder.innerHTML = message

  if (success) {
    holder.classList.remove('form-message-error')
  } else {
    holder.classList.add('form-message-error')
  }

  if (autoHide) {
    setTimeout(() => {
      holder.style.display = 'none'
    }, 5000)
  }
}

export const setupPaypal = (state, form) => {
  cleanupBeforeReload(state)
  debouncedLoadPaypalScript(state, form)
}

export const cleanupBeforeReload = (state) => {
  if (state.paypalButtons) {
    state.paypalButtons.close()
  }
}

export const loadPaypalScript = (state, form) => {
  const clientId = form ? form.dataset.paypalClientId : null
  const components = 'buttons'

  if (state.isRepeating) {
    window
      .paypalLoadScript({
        'client-id': clientId,
        vault: true,
        intent: 'subscription',
        components,
        'disable-funding': 'credit,card',
      })
      .then((paypal) => {
        renderPaypalButtons(state, form, paypal)
      })
  } else {
    window
      .paypalLoadScript({
        'client-id': clientId,
        vault: false,
        components,
        'disable-funding': 'credit,card',
      })
      .then((paypal) => {
        renderPaypalButtons(state, form, paypal)
      })
  }
}

export const renderPaypalButtons = (state, form, paypal) => {
  const submitButton = form ? form.querySelector('[name=action_submit]') : null
  const planId = state?.paypalPlanId

  const style = {
    layout: 'horizontal',
    color: 'white',
    height: 55,
    tagline: false,
  }
  let options = {}
  if (state.isRepeating) {
    options = {
      style: style,
      createSubscription: function (data, actions) {
        return actions.subscription.create({
          plan_id: planId,
        })
      },
      // eslint-disable-next-line no-unused-vars
      onApprove: function (data, actions) {
        const hiddenInput = document.createElement('input')
        hiddenInput.setAttribute('type', 'hidden')
        hiddenInput.setAttribute('name', 'paypalPayload')
        hiddenInput.setAttribute('value', JSON.stringify(data))
        form.appendChild(hiddenInput)
        form.forceSubmit = true
        submitButton.disabled = false
        submitButton.click()
        submitButton.disabled = true
      },
    }
  } else {
    options = {
      style: style,
      createOrder: function (data, actions) {
        return actions.order.create({
          purchase_units: [
            {
              amount: {
                value: state.currentTotal,
              },
            },
          ],
        })
      },
      onApprove: function (data, actions) {
        return actions.order
          .capture()
          .then(function (details) {
            const hiddenInput = document.createElement('input')
            hiddenInput.setAttribute('type', 'hidden')
            hiddenInput.setAttribute('name', 'paypalPayload')
            hiddenInput.setAttribute('value', JSON.stringify(details))
            form.appendChild(hiddenInput)
            submitButton.disabled = true
            form.submit()

            //form.forceSubmit = true
            //submitButton.disabled = false
            //submitButton.click()
            //submitButton.disabled = true
          })
          .catch((err) => {
            throw err
          })
      },
    }
  }
  paypal
    .Buttons(options)
    .render('#payment-paypal')
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.warn(`Warning - Caught an error when attempting to render component: ${err}`)
    })
}

export const debouncedLoadPaypalScript = debounce(loadPaypalScript, 500)
